import { network } from 'services/network';

export const bulkDeleteTags = (params) => {
    return network.post('api/bo/bulkDeleteTags', params).then((response) => {
        return response.data;
    });
};
